import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PriceRow } from "./PriceRow";
export const DeliveryFeeSection = (param)=>{
    let { deliveryFee  } = param;
    const { basicDeliveryCharge , remoteAreaFee  } = deliveryFee;
    const hasDeliveryFee = basicDeliveryCharge || remoteAreaFee;
    const totalDeliveryFee = (basicDeliveryCharge || 0) + (remoteAreaFee || 0);
    if (!hasDeliveryFee) return null;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ _jsx(PriceRow, {
                label: "배송비",
                amount: totalDeliveryFee,
                variant: "body1"
            }),
            basicDeliveryCharge > 0 && /*#__PURE__*/ _jsx(PriceRow, {
                label: "기본 배송비",
                amount: basicDeliveryCharge,
                variant: "body2",
                showIcon: true
            }),
            remoteAreaFee > 0 && /*#__PURE__*/ _jsx(PriceRow, {
                label: "도서산간 배송비",
                amount: remoteAreaFee,
                variant: "body2",
                showIcon: true
            })
        ]
    });
};
